import { EducationHub } from '../components/EducationHub';

export function EducationTool() {
  return <EducationHub />;
}
